import {useNuxtApp} from 'nuxt/app';
import {type ApplicationContextInterface} from '@@/package/application/applicationContext';

export const useContainer = <T>(dependencyId: string): T => {
    const {$container} = useNuxtApp();
    return ($container as ApplicationContextInterface).getService(dependencyId);
};
